import React from "react";
import { X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { PaneHeader } from "@/components/ui/pane-header";

/** The form screen's right panel: the form's comment threads. */
export function FormSidePanel({
  commentCount,
  onClose,
  children
}: {
  /** Open threads, once comments report them. */
  commentCount?: number;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return (
    <aside
      data-slot="form-side-panel"
      className="flex h-full w-90 flex-none flex-col border-l border-line-2 bg-surface"
    >
      <PaneHeader
        title="Comments"
        count={commentCount || null}
        className="pr-1.5"
        actions={
          <Button
            type="button"
            variant="ghost"
            size="icon-xs"
            aria-label="Close Comments"
            title="Close Comments"
            onClick={onClose}
          >
            <X />
          </Button>
        }
      />
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
    </aside>
  );
}
